import Loadable from '../../../components/loadable';

const ContactGradings = Loadable({
  loader: () => import('../../../pages/contacts/gradings'),
  type: 'block',
});

angular.module('gym').value('ContactGradings', ContactGradings);
